export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const script = document.createElement('script')
    script.src = 'https://chat-assets.frontapp.com/v1/chat.bundle.js'
    script.async = true
    script.defer = true
    script.onload = () => {
      if (window.FrontChat) {
        window.FrontChat('init', {
          chatId: '91ce129461ef6e2a565e54c81b2079e4',
          onInitCompleted: () => {
            const iframe = document.getElementById('front-chat-iframe')

            // wait a little bit for Front JS to end changing the widget height
            if (iframe) {
              setTimeout(() => {
                iframe.style.height = '100px'
              }, 1000)
            }

            window?.FrontChat?.(
              'onWindowVisibilityChanged',
              (isWindowVisible: boolean) => {
                if (iframe) {
                  if (isWindowVisible) {
                    iframe.style.height = '100%'
                  } else {
                    iframe.style.height = '100px'
                  }
                }
              },
            )
          },
          useDefaultLauncher: true,
        })
      }
    }
    document.head.appendChild(script)
  }
})
